import dataviewUtils from "_dataview/output/utils/index.js";
import layer from "_dataview/output/utils/layer.js";
import styles from "_dataview/output/dataviewStyle/index.js";
import {
  unitValueMap,
  fontList,
} from "_dataview/output/config/commonConfig.js";

if (!dsf.dataview) {
  dsf.dataview = {}
}
!function (global) {
  let $$dataviewConfig = global.$$dataviewConfig || {};
  let { $eventTemplate, $dataviewFonts, $dataviewStyles, $extendGis } = $$dataviewConfig
  //额外伪代码事件
  dsf.dataview.eventTemplate = $eventTemplate
  //拓展gis
  dsf.dataview.extendGis = $extendGis
  //字体文件
  dsf.dataview.fonts = fontList
  let dataviewFonts = $dataviewFonts
  if (dataviewFonts) {
    dsf.dataview.fonts.push(...dataviewFonts);
  }
  //大屏风格
  dsf.dataview.styles = styles
  let dataviewStyles = $dataviewStyles
  if (dataviewStyles) {
    dsf.dataview.styles.push(...dataviewStyles);
  }
  //大屏单位
  dsf.dataview.units = unitValueMap

  if (dsf.dataview.utils) {
    dsf.dataview.utils = dsf.mix(true, {}, dsf.dataview.utils, { ...dataviewUtils });
  } else {
    dsf.dataview.utils = dataviewUtils
  }
  if (dsf.dataview.layer) {
    dsf.dataview.layer = dsf.mix(true, {}, dsf.dataview.layer, { ...layer });
  } else {
    dsf.dataview.layer = layer
  }

}(dsf.global || (dsf.global = {}))
